import ERP from "@apiV2/ERP.mjs";
import Schema from "@apiV2/Schema.mjs";
import OrdemDeServicoItemService from "./OrdemDeServicoItemService";
import UtilSequence from "@/utils/UtilSequence.mjs";
import UtilDateTime from "@/utils/UtilDateTime";

export default {

    async gerarListaDeEmbarqueDeCliente(listaDeEmbarqueValores = {}){

        let listaDeEmbarque;

        try{

            //==================================================================//
            //============================ Pega Job ============================//
            //==================================================================//

            let jobID = listaDeEmbarqueValores.job;

            let job = await ERP.getOneById(Schema.JOB, jobID);
            if(job.status != 200){
                throw job;
            }

            //==================================================================//
            //====================== Pega Ordem de Serviço =====================//
            //==================================================================//

            let ordemDeServicoID = listaDeEmbarqueValores.ordemDeServico;

            let ordemDeServico = await ERP.getOneById(Schema.ORDEM_DE_SERVICO, ordemDeServicoID);
            if(ordemDeServico.status != 200){
                throw ordemDeServico;
            }

            //==================================================================//
            //=========== Pega Listas de Embarque Proxima Sequencia ============//
            //======== Sequencia é Definida com base na Ordem de Serviço =======//
            //==================================================================//

            let listasDeEmbarque = await ERP.getManyByValue(Schema.LISTA_DE_EMBARQUE, "ordemDeServico", ordemDeServicoID);
            if(listasDeEmbarque.status != 200 && listasDeEmbarque.status != 404){
                throw listasDeEmbarque;
            }

            let listasDeEmbarqueQuantidade = listasDeEmbarque?.data?.length || 0;
            let listasDeEmbarqueSequenciaProxima = listasDeEmbarqueQuantidade + 1;

            //==================================================================//
            //================ Cria Itens Lista de Embarque ====================//
            //==================================================================//

            let listasDeEmbarqueItens = await UtilSequence.each({
                list: listaDeEmbarqueValores.itens,
                callback: async (listaDeEmbarqueItemValores, index)=>{

                    //==================================================================//
                    //================== Pega Ordem de Serviço Item ====================//
                    //==================================================================//

                    let ordemDeServicoID = listaDeEmbarqueItemValores.ordemDeServicoItem;

                    let ordemDeServico = await ERP.getOneById(Schema.ORDEM_DE_SERVICO_ITENS, ordemDeServicoID);
                    if(ordemDeServico.status != 200){
                        throw ordemDeServico;
                    }

                    //==================================================================//
                    //================= Altera Ordem de Serviço Item ===================//
                    //==================================================================//

                    let ordemDeServicoStatus = ordemDeServico?.data?.status;
                    let ordemDeServicoQuantidadeParaEmbarcar = ordemDeServico?.data?.quantidadeParaEmbarcar - listaDeEmbarqueItemValores.quantidadeEmbarcando;
                    let ordemDeServicoQuantidadeEmbarcada = ordemDeServico?.data?.quantidadeEmbarcada + listaDeEmbarqueItemValores.quantidadeEmbarcando;
                    let ordemDeServicoQuantidadeParaEntregar = ordemDeServico?.data?.quantidadeParaEntregar + listaDeEmbarqueItemValores.quantidadeEmbarcando;

                    if(ordemDeServicoQuantidadeParaEmbarcar == 0){

                        ordemDeServicoStatus = "ET";

                    }

                    let ordemDeServicoValores = {
                        id: ordemDeServicoID,
                        status: ordemDeServicoStatus,
                        quantidadeParaEmbarcar: ordemDeServicoQuantidadeParaEmbarcar,
                        quantidadeEmbarcada: ordemDeServicoQuantidadeEmbarcada,
                        quantidadeParaEntregar: ordemDeServicoQuantidadeParaEntregar,
                    }

                    ordemDeServico = await OrdemDeServicoItemService.alterarItem(ordemDeServicoValores);
                    if(ordemDeServico.status != 200){
                        throw ordemDeServico;
                    }

                    //==================================================================//
                    //================ Cria Item da Lista de Embarque ==================//
                    //==================================================================//

                    let indexString = `${index+1}`;
                    let sequencia = indexString.padStart(3,"0");

                    listaDeEmbarqueItemValores = {
                        sequencia: sequencia || "000",
                        ordemDeServicoItem: listaDeEmbarqueItemValores?.ordemDeServicoItem || "",
                        descricao: listaDeEmbarqueItemValores?.descricao || "",
                        quantidade: listaDeEmbarqueItemValores?.quantidadeEmbarcando || 0,
                        unidade: listaDeEmbarqueItemValores?.unidade || "",
                        pesoTotal: 0, // Esse campo precisa de ajustes na tela para poder permitir passar o Peso de Cada Item.
                    }

                    let listaDeEmbarqueItem = await ERP.postOne(Schema.LISTA_DE_EMBARQUE_ITEM, listaDeEmbarqueItemValores);
                    if(listaDeEmbarqueItem.status != 200){
                        throw listaDeEmbarqueItem;
                    }

                    return listaDeEmbarqueItem.data;

                }
            });

            let listasDeEmbarqueItensIDs = listasDeEmbarqueItens.map(({id}) => id);

            //==================================================================//
            //===================== Cria Lista de Embarque =====================//
            //==================================================================//

            let jobCodigo = job?.data?.code || "";
            let ordemDeServicoCodigo = ordemDeServico?.data?.codigo || "";
            
            let listasDeEmbarqueCodigo = `LEM-${jobCodigo}-${ordemDeServicoCodigo}-${listasDeEmbarqueSequenciaProxima}`;

            let contratoInternoCodigo = `Job:${jobCodigo} - OS:${ordemDeServicoCodigo}`;
            let contratoExternoCodigo = `Job:${jobCodigo} - OS:${ordemDeServicoCodigo}`;

            let listasDeEmbarqueItensQuantidade = listaDeEmbarqueValores?.itens?.length || 0;

            listaDeEmbarqueValores = {
                codigo: listasDeEmbarqueCodigo || "",
                status: "Elaboração",
                destino: "Cliente",
                job: job?.data?.id || "",
                ordemDeServico: ordemDeServico?.data?.id || "",
                cliente: listaDeEmbarqueValores?.cliente || "",
                descricao: `Lista de Embarque do Job ${jobCodigo}, criada a partir da OS ${ordemDeServicoCodigo} com a Sequência ${listasDeEmbarqueSequenciaProxima}`,
                contratoInterno: contratoInternoCodigo || "",
                contratoExterno: contratoExternoCodigo || "",
                numeroVolumes: listasDeEmbarqueItensQuantidade || 0,
                dataCriacao: UtilDateTime.todayUTC() || "",
                responsavel: listaDeEmbarqueValores?.responsavel || "",
                observacao: listaDeEmbarqueValores?.observacao || "",
                itens: listasDeEmbarqueItensIDs || [],
            }

            listaDeEmbarque = await ERP.postOne(Schema.LISTA_DE_EMBARQUE, listaDeEmbarqueValores);
            if(listaDeEmbarque.status != 200){
                throw listaDeEmbarque;
            }

            console.log(listaDeEmbarque);

        }catch(e){

            console.log(e);
            return listaDeEmbarque;

        }

        return listaDeEmbarque;

    },

    async gerarListaDeEmbarqueDeFornecedor(listaDeEmbarqueValores = {}){

        let listaDeEmbarque;

        try{

            //==================================================================//
            //============================ Pega Job ============================//
            //==================================================================//

            let jobID = listaDeEmbarqueValores.job;

            let job = await ERP.getOneById(Schema.JOB, jobID);
            if(job.status != 200){
                throw job;
            }

            //==================================================================//
            //====================== Pega Ordem de Serviço =====================//
            //==================================================================//

            let ordemDeServicoID = listaDeEmbarqueValores.ordemDeServico;

            let ordemDeServico = await ERP.getOneById(Schema.ORDEM_DE_SERVICO, ordemDeServicoID);
            if(ordemDeServico.status != 200){
                throw ordemDeServico;
            }

            //==================================================================//
            //=========== Pega Listas de Embarque Proxima Sequencia ============//
            //======== Sequencia é Definida com base na Ordem de Serviço =======//
            //==================================================================//

            let listasDeEmbarque = await ERP.getManyByValue(Schema.LISTA_DE_EMBARQUE, "ordemDeServico", ordemDeServicoID);
            if(listasDeEmbarque.status != 200 && listasDeEmbarque.status != 404){
                throw listasDeEmbarque;
            }

            let listasDeEmbarqueQuantidade = listasDeEmbarque?.data?.length || 0;
            let listasDeEmbarqueSequenciaProxima = listasDeEmbarqueQuantidade + 1;

            //==================================================================//
            //================ Cria Itens Lista de Embarque ====================//
            //==================================================================//

            let listasDeEmbarqueItens = await UtilSequence.each({
                list: listaDeEmbarqueValores.itens,
                callback: async (listaDeEmbarqueItemValores, index)=>{

                    //==================================================================//
                    //================== Pega Ordem de Serviço Item ====================//
                    //==================================================================//

                    let ordemDeServicoID = listaDeEmbarqueItemValores.ordemDeServicoItem;

                    let ordemDeServico = await ERP.getOneById(Schema.ORDEM_DE_SERVICO_ITENS, ordemDeServicoID);
                    if(ordemDeServico.status != 200){
                        throw ordemDeServico;
                    }

                    //==================================================================//
                    //================= Altera Ordem de Serviço Item ===================//
                    //==================================================================//

                    let ordemDeServicoStatus = ordemDeServico?.data?.status;
                    let ordemDeServicoQuantidadeParaEmbarcar = ordemDeServico?.data?.quantidadeParaEmbarcar - listaDeEmbarqueItemValores.quantidadeEmbarcando;
                    let ordemDeServicoQuantidadeEmbarcada = ordemDeServico?.data?.quantidadeEmbarcada + listaDeEmbarqueItemValores.quantidadeEmbarcando;
                    let ordemDeServicoQuantidadeParaEntregar = ordemDeServico?.data?.quantidadeParaEntregar + listaDeEmbarqueItemValores.quantidadeEmbarcando;

                    if(ordemDeServicoQuantidadeParaEmbarcar == 0){

                        ordemDeServicoStatus = "ET";

                    }

                    let ordemDeServicoValores = {
                        id: ordemDeServicoID,
                        status: ordemDeServicoStatus,
                        quantidadeParaEmbarcar: ordemDeServicoQuantidadeParaEmbarcar,
                        quantidadeEmbarcada: ordemDeServicoQuantidadeEmbarcada,
                        quantidadeParaEntregar: ordemDeServicoQuantidadeParaEntregar,
                    }

                    ordemDeServico = await OrdemDeServicoItemService.alterarItem(ordemDeServicoValores);
                    if(ordemDeServico.status != 200){
                        throw ordemDeServico;
                    }

                    //==================================================================//
                    //================ Cria Item da Lista de Embarque ==================//
                    //==================================================================//

                    let indexString = `${index+1}`;
                    let sequencia = indexString.padStart(3,"0");

                    listaDeEmbarqueItemValores = {
                        sequencia: sequencia || "000",
                        ordemDeServicoItem: listaDeEmbarqueItemValores?.ordemDeServicoItem || "",
                        descricao: listaDeEmbarqueItemValores?.descricao || "",
                        quantidade: listaDeEmbarqueItemValores?.quantidadeEmbarcando || 0,
                        unidade: listaDeEmbarqueItemValores?.unidade || "",
                        pesoTotal: 0, // Esse campo precisa de ajustes na tela para poder permitir passar o Peso de Cada Item.
                    }

                    let listaDeEmbarqueItem = await ERP.postOne(Schema.LISTA_DE_EMBARQUE_ITEM, listaDeEmbarqueItemValores);
                    if(listaDeEmbarqueItem.status != 200){
                        throw listaDeEmbarqueItem;
                    }

                    return listaDeEmbarqueItem.data;

                }
            });

            let listasDeEmbarqueItensIDs = listasDeEmbarqueItens.map(({id}) => id);

            //==================================================================//
            //===================== Cria Lista de Embarque =====================//
            //==================================================================//

            let jobCodigo = job?.data?.code || "";
            let ordemDeServicoCodigo = ordemDeServico?.data?.codigo || "";
            
            let listasDeEmbarqueCodigo = `LEM-${jobCodigo}-${ordemDeServicoCodigo}-${listasDeEmbarqueSequenciaProxima}`;

            let contratoInternoCodigo = `Job:${jobCodigo} - OS:${ordemDeServicoCodigo}`;
            let contratoExternoCodigo = `Job:${jobCodigo} - OS:${ordemDeServicoCodigo}`;

            let listasDeEmbarqueItensQuantidade = listaDeEmbarqueValores?.itens?.length || 0;

            listaDeEmbarqueValores = {
                codigo: listasDeEmbarqueCodigo || "",
                status: "Elaboração",
                destino: "Fornecedor",
                job: job?.data?.id || "",
                ordemDeServico: ordemDeServico?.data?.id || "",
                fornecedor: listaDeEmbarqueValores?.fornecedor || "",
                descricao: `Lista de Embarque do Job ${jobCodigo}, criada a partir da OS ${ordemDeServicoCodigo} com a Sequência ${listasDeEmbarqueSequenciaProxima}`,
                contratoInterno: contratoInternoCodigo || "",
                contratoExterno: contratoExternoCodigo || "",
                numeroVolumes: listasDeEmbarqueItensQuantidade || 0,
                dataCriacao: UtilDateTime.todayUTC() || "",
                responsavel: listaDeEmbarqueValores?.responsavel || "",
                observacao: listaDeEmbarqueValores?.observacao || "",
                itens: listasDeEmbarqueItensIDs || [],
            }

            listaDeEmbarque = await ERP.postOne(Schema.LISTA_DE_EMBARQUE, listaDeEmbarqueValores);
            if(listaDeEmbarque.status != 200){
                throw listaDeEmbarque;
            }

            console.log(listaDeEmbarque);

        }catch(e){

            console.log(e);
            return listaDeEmbarque;

        }

        return listaDeEmbarque;

    },

    async retornarParaAlmoxarifado(ordemDeServicoItemValores = {}){

        let ordemDeServicoItens;

        try{

            //==================================================================//
            //================== Altera Ordem de Serviço Item ==================//
            //==================================================================//

            ordemDeServicoItemValores = ordemDeServicoItemValores.map((ordemDeServicoItemValor)=>{

                return{
                    id: ordemDeServicoItemValor?.id,
                    status: "LA"
                }

            });

            ordemDeServicoItens = await OrdemDeServicoItemService.alterarItens(ordemDeServicoItemValores);
            if(ordemDeServicoItens.status != 200){
                throw ordemDeServicoItens;
            }

        }catch(e){

            console.log(e);
            return ordemDeServicoItens;

        }

        return ordemDeServicoItens;

    },

    async darBaixaParaEntregue(ordemDeServicoItemValores = {}){

        let ordemDeServicoItens;

        try{

            //==================================================================//
            //================== Altera Ordem de Serviço Item ==================//
            //==================================================================//

            ordemDeServicoItemValores = ordemDeServicoItemValores.map((ordemDeServicoItemValor)=>{

                return{
                    id: ordemDeServicoItemValor?.id,
                    status: "ET"
                }

            });

            ordemDeServicoItens = await OrdemDeServicoItemService.alterarItens(ordemDeServicoItemValores);
            if(ordemDeServicoItens.status != 200){
                throw ordemDeServicoItens;
            }

        }catch(e){

            console.log(e);
            return ordemDeServicoItens;

        }

        return ordemDeServicoItens;

    },

}